import React, { type ReactElement } from 'react';

import { Color } from '@pushwoosh/kit-constants';
import { Text } from '@pushwoosh/kit-typography';

import { Lang } from '~/src/polyglot';

import { HorizontalLine } from './styles';

export function Separator(): ReactElement {
  return (
    <HorizontalLine>
      <hr />
      <Text $color={Color.LOCKED} $textTransform="uppercase"><Lang message="SEPARATOR.OR" /></Text>
      <hr />
    </HorizontalLine>
  );
}
